import { useEffect, useState } from "react";
import PageContainer from "../components/pageContainer/PageContainer";
import SettingsLayout from "../components/settings/SettingsLayout";
import Button from "../components/button";
import { Check, JobbizIcon, PeopulseIcon } from "../assets/icons";
import useTitle from "../hooks/TitleManager";
import ApiDatabase from "../server";

const IntegrationCard = ({ icon, title, description, connected }) => (
  <div className="flex items-center gap-4 rounded-lg border p-4">
    <div className="flex h-12 w-12 shrink-0 items-center justify-center">
      {icon}
    </div>
    <div className="flex flex-1 flex-col">
      <div className="ft-lg font-semibold text-gray-900">{title}</div>
      <div className="ft-sm text-gray-500">{description}</div>
    </div>
    <div className="shrink-0">
      {connected ? (
        <div className="flex items-center gap-1">
          <Check wh={20} color="#047857" />
          <span className="text-green-700 ft-sm font-medium">Connecté</span>
        </div>
      ) : (
        <Button color="DISABLED" size="LG">
          Connecter
        </Button>
      )}
    </div>
  </div>
);

const SettingsIntegrations = () => {
  useTitle({ title: "Paramètres - Intégrations" });
  const [integrations, setIntegrations] = useState({
    peopulse: false,
    jobbiz: false,
  });

  useEffect(() => {
    ApiDatabase.getUserInfo(
      {},
      (data) => {
        if (data?.user?.integrations) {
          setIntegrations({
            peopulse: Boolean(data.user.integrations.peopulse),
            jobbiz: Boolean(data.user.integrations.jobbiz),
          });
        }
      },
      (err) => {
        console.error("settings integrations user info", err);
      }
    );
  }, []);

  return (
    <PageContainer type="organization_settings_integrations">
      <SettingsLayout>
        <div className="flex flex-col gap-6">
          <h1 className="ft-xl font-semibold text-gray-900 pl-4">
            Intégrations
          </h1>
          <div className="flex flex-col gap-4">
            <IntegrationCard
              icon={<PeopulseIcon wh={48} />}
              title="Peopulse"
              description="Imports automatique des missions et export des heures sur Peopulse."
              connected={integrations.peopulse}
            />
            <IntegrationCard
              icon={<JobbizIcon wh={48} />}
              title="Jobbiz"
              description="Imports automatique des missions et export des heures sur Jobbiz."
              connected={integrations.jobbiz}
            />
          </div>
        </div>
      </SettingsLayout>
    </PageContainer>
  );
};

export default SettingsIntegrations;
